import { render } from "./WalletPage.vue?vue&type=template&id=092b6d90&scoped=true"
import script from "./WalletPage.vue?vue&type=script&lang=js"
export * from "./WalletPage.vue?vue&type=script&lang=js"

import "./WalletPage.vue?vue&type=style&index=0&id=092b6d90&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-092b6d90"]])

export default __exports__